// Explore data for the app. Normal case: one small, cached JSON from the render server (/data/explore).
// Fallback (dev server, or the render server cannot reach PocketBase): load the reports straight from
// PocketBase once and reduce them in the browser with the same code (scripts/explore-data.js).
import { build, part, FILTER, FIELDS } from '../../scripts/explore-data';

let local = null;

async function fromServer(params) {
  const res = await fetch('/data/explore?' + new URLSearchParams(params), { headers: { Accept: 'application/json' } });
  if (!res.ok || !(res.headers.get('content-type') || '').includes('json')) throw new Error('no explore endpoint');
  return res.json();
}

async function fromPocketBase(pb) {
  if (!local) {
    local = (async () => {
      const items = [];
      for (let page = 1; page <= 10; page += 1) {
        const data = await pb.collection('reports').getList(page, 500, { filter: FILTER, sort: '-created,id', fields: FIELDS, skipTotal: true });
        items.push(...data.items);
        if (data.items.length < 500) break;
      }
      return build(items);
    })().catch((e) => { local = null; throw e; });
  }
  return local;
}

let serverOk = true;
export async function exploreData(pb, params) {
  if (serverOk) {
    try { return await fromServer(params); } catch (e) { serverOk = false; }
  }
  return part(await fromPocketBase(pb), params);
}
